import { createAllActions } from 'web-app/util/redux/typed-action-helpers';
export const { success: fetchAccountSuccess } = createAllActions('ACCOUNT/FETCH_ACCOUNT', () => ({}), (account) => ({ account }));
